<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
 
}
</script>

<style>
body, #app{
  
  width: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  /* overflow: hidden; */
}

html{
  padding: 0;
  margin: 0;
  overflow-x: hidden;
}
</style>
